import api from "./api";

export interface ManagedUser {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: "user" | "admin" | "super_admin";
  status: "pending" | "active" | "suspended";
  isActive?: boolean;
  lastLogin?: string;
  createdAt: string;
  statusChangedBy?: { _id: string; email: string } | null;
  statusChangedAt?: string | null;
}

export interface UsersListResponse {
  success: boolean;
  users: ManagedUser[];
  pagination: {
    current_page: number;
    per_page: number;
    total_pages: number;
    total_items: number;
  };
  counts: {
    pending: number;
    active: number;
    suspended: number;
  };
}

export const listUsers = async (params: {
  status?: string;
  page?: number;
  limit?: number;
}): Promise<UsersListResponse> => {
  const { data } = await api.get<UsersListResponse>("/api/admin/users", {
    params,
  });
  return data;
};

export const approveUser = async (id: string): Promise<ManagedUser> => {
  const { data } = await api.post(`/api/admin/users/${id}/approve`);
  return data.user;
};

export const suspendUser = async (id: string): Promise<ManagedUser> => {
  const { data } = await api.post(`/api/admin/users/${id}/suspend`);
  return data.user;
};

export const setUserRole = async (
  id: string,
  role: "user" | "admin"
): Promise<ManagedUser> => {
  const { data } = await api.post(`/api/admin/users/${id}/role`, { role });
  return data.user;
};
